<template>
	<div class="classify page-container">
		<custom-table :pageConfig="pageConfig" :multipleSelection="multipleSelection" :buttonGroup="buttonGroup"
			:filterValue="filterValue" :tableFilter="tableFilter" :tableConfig="tableConfig" :tableData="tableData"
			@pageChange="pageChange" @buttonClick="buttonClick" @filterChange="filterChange"
			@scopeButtonClick="scopeButtonClick">
		</custom-table>
		<!-- 编辑信息 -->
		<el-dialog title="编辑分类" :visible.sync="dialogFormVisible" width="500px" custom-class="generalDialog">
			<el-form ref="categoryForm" :model="categoryForm" :label-width="categoryFormLabelWidth"
				:rules="categoryFormRules">
				<el-form-item label="分类名称" prop="name">
					<el-input v-model="categoryForm.name" autocomplete="off" placeholder="请输入分类名称" clearable></el-input>
				</el-form-item>
				<el-form-item label="父级分类" prop="parent">
					<el-select v-model="categoryForm.parent" placeholder="请选择父级分类" clearable>
						<el-option v-for="(item,index) in parentList" :key="index" :label="item.typeName"
							:value="item.lotTypeId">
						</el-option>
					</el-select>
					<div class="hint">
						如添加一级分类，请勿选择父级。<br>
						如添加二级分类，请选择父级
					</div>
				</el-form-item>
				<!-- <el-form-item label="分类状态" prop="status">
					<el-select v-model="categoryForm.status" placeholder="请选择分类状态" clearable>
						<el-option v-for="(item,index) in statusList" :key="index" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item> -->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="DialogClose">取 消</el-button>
				<el-button type="primary" :loading="loading" @click="DialogConfirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'classify',
		data() {
			return {
				dialogFormVisible: false,
				categoryForm: {
					name: '',
					parent: '',
					// status: ''
				},
				parentList: [],
				// statusList: [{
				// 	label: '启用',
				// 	value: 1
				// }, {
				// 	label: '禁用',
				// 	value: 0
				// }],
				categoryFormLabelWidth: '80px',
				categoryFormRules: {
					name: [{
						required: true,
						trigger: 'blur',
						message: '请输入分类名称'
					}],
					// status: [{
					// 	required: true,
					// 	trigger: 'blur',
					// 	message: '请选择分类状态'
					// }],
				},
				loading: false,
				// 表格
				pageConfig: {
					totalWord: '全部数据',
					total: 0,
					pageSize: 13,
					currentPage: 1,
				},
				multipleSelection: [],
				buttonGroup: [{
					type: 'primary',
					size: 'mini',
					plain: true,
					icon: 'el-icon-plus',
					word: '添加分类',
					sign: 'new'
				}],
				filterValue: {},
				tableFilter: [],
				tableConfig: {
					border: true,
					selection: false,
					showOverflowTooltip: true,
					tableHeader: [{
							prop: 'typeName',
							label: '分类名称',
							width: 350
						},
						{
							prop: 'typeLevel',
							label: '分类级别',
							width: 350,
							template: true
						},
						{
							prop: 'parentId',
							label: '父级分类',
							width: 270
						},
						{
							prop: 'createAt',
							label: '创建时间',
							width: 250
						},
						// {
						// 	prop: 'status',
						// 	label: '当前状态',
						// 	width: 150
						// }
					],
					tableEvent: [{
							icon: 'el-icon-edit',
							name: '编辑',
							color: 'blue',
							sign: 'edit'
						},
						{
							icon: 'el-icon-delete',
							name: '删除',
							color: 'red',
							sign: 'delete'
						}
					],
					emptyDescription: '当前没有数据',
				},
				tableData: [],
				operationId: ''
			};
		},
		methods: {
			pageChange() {
				this.fetchData()
			},
			buttonClick(sign) {
				console.log(sign);
				if (sign === 'new') {
					this.dialogFormVisible = true
				}
			},
			filterChange() {
				console.log(this.filterValue);
			},
			scopeButtonClick(row, sign) {
				console.log(row, sign)
				this.operationId = row.lotTypeId
				if( sign === 'edit' ){
					this.categoryForm = {
						name: row.typeName,
						parent: row.parentId
					}
					this.dialogFormVisible = true
				}
				if ( sign === 'delete' ){
					this.$confirm('确认要删除这个分类吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$api.classifyDelete({
							lotTypeId: this.operationId
						}, res => {
							this.operationId = ''
							if (res.code == 200) {
								this.fetchData()
								this.fetchClassifyAll()
								this.$message({
									message: '删除成功',
									type: 'success',
									duration: 2000
								})
							}
						})
					}).catch(() => {});
				}
			},
			DialogClose() {
				this.dialogFormVisible = false
				this.operationId = ''
				this.categoryForm = {
					parent: '',
					name: ''
				}
			},
			DialogConfirm() {
				this.$refs.categoryForm.validate(valid => {
					if (valid) {
						this.loading = true
						this.$api.classifyEdit({
							lotTypeId:this.operationId,
							parentId:this.categoryForm.parent,
							typeName:this.categoryForm.name,
							typeLevel:this.categoryForm.parent == '' ? 1 : 2
						},res=>{
							this.loading = false
							if(res.code==200){
								this.$message({
									message: (this.operationId == '' ? '新增' : '编辑') + '分类成功！',
									duration: 2000,
									type: 'success',
									onClose: () => {
								
									}
								})
								this.DialogClose()
								// this.resetFilter()
								this.fetchData()
								this.fetchClassifyAll()
							}
						})
					}
				})
			},
			fetchData() {
				this.$api.classifyList({
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage
				}, res => {
					if (res.code == 200) {
						this.tableData = res.data.list
						this.pageConfig.total = res.data.total
					}
				})
			},
			fetchClassifyAll() {
				this.$api.classifyAll({}, res => {
					if (res.code == 200) {
						this.parentList = res.data
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
			this.fetchClassifyAll()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.hint {
		width: 100%;
		line-height: 20px;
		padding-top: @vue-spacing-col-sm;
		font-size: @vue-font-size-min;
		box-sizing: border-box;
		color: @vue-text-color-red;
	}
</style>
